import React from 'react';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';
import { WebContent } from '@interlayer/js/components/system/WebContent/WebContent';

import { useOpenChat } from '@core/js/components/system/CommunicationWidgets/hooks';
import { useTranslations } from '@core/js/hooks/i18n';
import { componentService } from '@core/js/services/component.service';

import { clsx } from '@interlayer/js/app/utils/clsx.util';
import { useIsShowChat } from '@interlayer/js/components/system/CommunicationWidgets/buzz/hooks/useIsShowChat';

import { TContactsBlockGlobalProps } from './types';

import style from './ContactsBlock.scss';

export const ContactsBlockGlobal: React.FC<TContactsBlockGlobalProps> = ({ ishorizontally, iswhite, children } = {}) => {
    const openChat = useOpenChat();
    const isShowChat = useIsShowChat();
    const t = useTranslations('playtech.mobile.system.contacts.');

    return (
        <div className={clsx(
            style.wrap,
            {
                [style.isHorizontally]: ishorizontally,
                [style.isWhite]: iswhite
            })}
        >
            {children}

            {isShowChat && (
                <div data-testid="ContactsBlock_chat" className={style.link} onClick={openChat}>
                    <SvgIcon className={style.icon} type="chat" />

                    <span className={style.label}>{t('chat')}</span>
                </div>
            )}
        </div>
    );
};

export const ContactsBlock: React.FC<{ className?: string }> = ({ className }) => (
    <WebContent id="CONTACT_BLOCK" className={className} />
);

componentService.registerWebContentComponents({ ContactsBlock: ContactsBlockGlobal });
